














































import { Vue, Component, Prop } from 'vue-property-decorator'
import { TableList } from '@/shims-global'
import MainTitle from '../_components/MainTitle.vue'
import SubTitle from '../_components/SubTitle.vue'
import Page3Chart1 from '../_components/charts/Page3Chart1.vue'
import Page3Chart2 from '../_components/charts/Page3Chart2.vue'
@Component({
  components: {
    MainTitle,
    SubTitle,
    Page3Chart1,
    Page3Chart2
  }
})
export default class extends Vue {
  @Prop({}) private data!: any

  private list: any = [];

  created() {
    let obj: any = this.data.pie
    obj.DpaEnergyZoneTypeIntro = obj.title
    obj.data = []
    obj.names = []
    obj.normData = []
    console.info(obj)
    this.data.pie.dataList.map(v => {
      obj.names.push(v.name)
      obj.data.push(v.value)
      obj.normData.push(v.normValue)
    })
    console.info(obj)
    this.list.push(obj)
    this.data.energyZoneAvgScoreVosLine.map(v => {
      this.list.push(v)
    })
  }
}
